import type { UseQueryResult } from '@tanstack/react-query';
import { Icon, TFLoadingOverlay } from '@tf/ui';
import type React from 'react';

import { SimplePage } from '@/components/shared';

export function QueryLoader<Data>({
	query,
	errorMessage,
	renderData,
}: {
	query: UseQueryResult<Data, Error>;
	errorMessage: string;
	renderData: (data: Data) => React.ReactElement;
}) {
	if (query.isPending) {
		return <TFLoadingOverlay />;
	}

	if (query.status === 'error') {
		return (
			<SimplePage
				title={errorMessage}
				action={{
					icon: <Icon.IconReload />,
					label: 'Reload',
					onClick: () => query.refetch(),
				}}
			/>
		);
	}

	return renderData(query.data);
}
